import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class AppDetailsRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/app/')
  }

  async getAppDetails (id) {
    const data = await Repository.get(`${this.resource}${id}`)
    return data.data
  }
}
